import {Component, inject} from '@angular/core';
import {RefModelSidebarService} from '@q9elements/ui-kit/refmodels';
import {InternalNodeSidebarBaseTab} from '../../models/base-tab.component';
import {InternalNodeSidebarSubTabs} from '../../models/portals';

@Component({
  selector: 'q9rme-changes-tab',
  templateUrl: './changes-tab.component.html',
  styleUrls: ['./changes-tab.component.scss']
})
export class ChangesTabComponent extends InternalNodeSidebarBaseTab {
  override selectedTab = InternalNodeSidebarSubTabs.PlannedChangesTab;
  private sidebarService = inject(RefModelSidebarService);

  public planedChangesTabCount = this.sidebarService.planedChangesTabCount;
  public feedbackTabCount = this.sidebarService.feedbackTabCount;
}
